<template>
  <v-dialog v-model="isOpen" max-width="600px" persistent scrollable>
    <v-card class="pa-4 rounded-xl">
      <v-card-title class="headline text-orange-darken-2 pb-2">
          <div class="d-flex align-center">
            <v-icon left class="mr-2" color="#1D1B59">fas fa-eye</v-icon>
            {{ $t("views.trips.create_trip.trip_observations") }}
          </div>
          <v-btn icon @click="$emit('close')" class="ml-auto">
            <v-icon color="#1D1B59">fas fa-close</v-icon>
          </v-btn>
      </v-card-title>
      <v-divider class="mb-4" />

      <v-card-text>
        <v-textarea v-model="observationsProxy" :label="$t('views.trips.create_trip.observations')" auto-grow outlined
          dense />
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn text color="grey" @click="$emit('close')">
          {{ $t("views.trips.create_trip.cancel") }}
        </v-btn>
        <v-btn color="orange darken-2" dark @click="saveObservations">
          {{ $t("views.trips.create_trip.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ObservacionesModal",
  props: {
    isOpen: Boolean,
    observations: String,
  },
  data() {
    return {
      observationsProxy: this.observations,
    };
  },
  watch: {
    observations(val) {
      this.observationsProxy = val;
    },
  },
  methods: {
    saveObservations() {
      this.$emit("update:observations", this.observationsProxy);
      this.$emit("close");
    },
  },
};
</script>